import { AccuracyBandAggregate } from "./accuracyBandAggregate";

interface AccuracyAggregateInspectionResultGroup {
  groupName: string;
  groupBandAggregates: AccuracyBandAggregate[];
  inspectionGroupUid: string;
  results: AccuracyAggregateInspectionResult[];
}

interface AccuracyInspectionResponse {
  aggregates: AccuracyAggregateInspectionResultGroup[];
  inspectionResultReasons: AccuracyInspectionResultReasonsPerGroup[]
}

interface AccuracyInspectionResultReasonsPerGroup {
  inspectionUid: string;
  inaccurate: Map<string, number>;
  accurate: Map<string, number>;
  suspect: Map<string, number>;
  enriched: Map<string, number>;
  skipped: Map<string, number>;
}

enum NumericResultType {
  Count,
  Percent,
  Score,
}

interface AccuracyAggregateInspectionResult {
  accuracyIndex: number;
  inspectionUid: string;
  name: string;
  providerCount: number;
  providerPassPercentage: number;
  providerFailPercentage: number;
  bandAggregates: AccuracyBandAggregate[];
}

export {
  AccuracyAggregateInspectionResult,
  AccuracyAggregateInspectionResultGroup,
  AccuracyInspectionResponse,
  AccuracyInspectionResultReasonsPerGroup,
  NumericResultType
};
